import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type StatusKind =
  | 'blocked'
  | 'archived'
  | 'single-shot'
  | 'pending'
  | 'in_progress'
  | 'done'
  | 'default';

interface StatusBadgeProps {
  kind: StatusKind;
  children?: string;
  className?: string;
}

const config: Record<
  StatusKind,
  { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }
> = {
  blocked: { label: 'Blocked', variant: 'destructive' },
  archived: { label: 'Archived', variant: 'secondary' },
  'single-shot': { label: 'Single-shot', variant: 'outline' },
  pending: { label: 'Pending', variant: 'outline' },
  in_progress: { label: 'In progress', variant: 'secondary' },
  done: { label: 'Done', variant: 'secondary' },
  default: { label: '', variant: 'secondary' },
};

export default function StatusBadge({ kind, children, className }: StatusBadgeProps) {
  const { label, variant } = config[kind];

  return (
    <Badge variant={variant} className={cn('font-normal', className)}>
      {children ?? label}
    </Badge>
  );
}
